// extracted by mini-css-extract-plugin
module.exports = {"root":"Invoice_root__c96Et","invoiceLogo":"Invoice_invoiceLogo__1ZYl6","invoiceBody":"Invoice_invoiceBody__28-F0"};